import { initializeErrorReporting } from '@eventbrite/error-reporting';
import {
    getLocaleOverride,
    getParentLocale,
    setupAsync,
} from '@eventbrite/i18n';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eventbrite/site-analytics';
import React from 'react';
import { hydrate, render } from 'react-dom';
import App from './app';
import { initDatadogRUM } from './initDatadogRUM';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};
const root = document.getElementById('root');
const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

const isProd = (domain: string) => domain?.includes('eventbrite');

const SENTRY_PROD_DSN =
    'https://e8b864d1104749329cd2b6a95d243f06@o375540.ingest.us.sentry.io/6141610';

const SENTRY_QA_DSN =
    'https://55b36e27b839423aa72e84cb3bdd5cf7@o375540.ingest.us.sentry.io/6141610';

const getSentryDSN = (isProd: boolean) =>
    isProd ? SENTRY_PROD_DSN : SENTRY_QA_DSN;

const main = async () => {
    const isProdEnv = isProd(props.env.ebDomain);

    try {
        initializeErrorReporting({ dsn: getSentryDSN(isProdEnv) });
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations:
                    /* webpackChunkName: "checkout-bankredirect-i18n-translation" */ import(
                        `./i18n/translations/${parentLocale}.json`
                    ),
            });
        }
    } finally {
        if (props.env.remoteServerSideRendered) {
            hydrate(<App {...props} />, root);
        } else {
            render(<App {...props} />, root);
        }

        initDimensionsFromState(props);
        trackInitialPageView(props.gaSettings);

        if (isProdEnv) {
            initDatadogRUM({
                app: { name: props.app_name, version: props.app_version },
                user: props.user,
            });
        }
    }
};

main();
